<template>
  <div>
    <vs-input
        v-validate="'required|email|min:3'"
        data-vv-validate-on="blur"
        name="email"
        icon-no-border
        icon="icon icon-user"
        icon-pack="feather"
        placeholder="メールアドレス"
        v-model="email"
        class="w-full"/>
    <span class="text-danger text-sm">{{ errors.first('email') }}</span>

    <vs-input
        data-vv-validate-on="blur"
        type="password"
        name="password"
        icon-no-border
        icon="icon icon-lock"
        icon-pack="feather"
        placeholder="パスワード"
        v-model="password"
        class="w-full mt-2" />
    <span class="text-danger text-sm">{{ errors.first('password') }}</span>
    <!--
    <div class="flex flex-wrap justify-between mt-4">
        <vs-checkbox v-model="checkbox_remember_me">ログイン状態を保持</vs-checkbox>
        <router-link to="/pages/forgot-password">パスワードを忘れた方</router-link>
    </div>
    -->
    <!-- <vs-button  type="border" @click="registerUser">新規登録</vs-button> -->
    <div class="social-login-buttons flex flex-wrap mt-4 items-center">
      <vs-button :disabled="!validateForm" @click="login">ログイン</vs-button>
    </div>

    <vs-divider class="mt-8 mb-4"></vs-divider>

    <div class="social-login-buttons flex flex-wrap items-center mt-4">

      <!-- facebook -->
      <!--
      <div class="bg-facebook pt-3 pb-2 px-4 rounded-lg cursor-pointer mr-4" @click="loginWithFacebook">
        <svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="facebook-f" class="text-white h-4 w-4 svg-inline--fa fa-facebook-f fa-w-9" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 264 512"><path fill="currentColor" d="M215.8 85H264V3.6C255.7 2.5 227.1 0 193.8 0 124.3 0 76.7 42.4 76.7 120.3V192H0v91h76.7v229h94V283h73.6l11.7-91h-85.3v-62.7c0-26.3 7.3-44.3 45.1-44.3z"></path></svg>
      </div>
      -->

      <!-- TWITTER -->
      <!--
      <div class="bg-twitter pt-3 pb-2 px-4 rounded-lg cursor-pointer mr-4" @click="loginWithTwitter">
        <svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="twitter" class="text-white h-4 w-4 svg-inline--fa fa-twitter fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"></path></svg>
      </div>
      -->

      <!-- GOOGLE -->
      <div class="pt-3 pb-3 px-4 rounded-lg cursor-pointer vs-button text-center btn-gmail" @click="loginWithGoogle">
        <i><img src="@/assets/images/logo/btn_google.svg"></i>
        Googleでログイン
      </div>

      <vs-divider class="my-4"></vs-divider>

      <!-- Apple -->
      <div class="pt-3 pb-3 px-4 rounded-lg cursor-pointer vs-button text-center btn-apple" @click="loginWithApple">
        <i><img src="@/assets/images/logo/btn_apple.svg"></i>Sign in with Apple
      </div>


      

      <!-- GITHUB -->
      <!--
      <div class="bg-github pt-3 pb-2 px-4 rounded-lg cursor-pointer mr-4" @click="loginWithGithub">
        <svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="github-alt" class="text-white h-4 w-4 svg-inline--fa fa-github-alt fa-w-15" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 480 512"><path fill="currentColor" d="M186.1 328.7c0 20.9-10.9 55.1-36.7 55.1s-36.7-34.2-36.7-55.1 10.9-55.1 36.7-55.1 36.7 34.2 36.7 55.1zM480 278.2c0 31.9-3.2 65.7-17.5 95-37.9 76.6-142.1 74.8-216.7 74.8-75.8 0-186.2 2.7-225.6-74.8-14.6-29-20.2-63.1-20.2-95 0-41.9 13.9-81.5 41.5-113.6-5.2-15.8-7.7-32.4-7.7-48.8 0-21.5 4.9-32.3 14.6-51.8 45.3 0 74.3 9 108.8 36 29-6.9 58.8-10 88.7-10 27 0 54.2 2.9 80.4 9.2 34-26.7 63-35.2 107.8-35.2 9.8 19.5 14.6 30.3 14.6 51.8 0 16.4-2.6 32.7-7.7 48.2 27.5 32.4 39 72.3 39 114.2zm-64.3 50.5c0-43.9-26.7-82.6-73.5-82.6-18.9 0-37 3.4-56 6-14.9 2.3-29.8 3.2-45.1 3.2-15.2 0-30.1-.9-45.1-3.2-18.7-2.6-37-6-56-6-46.8 0-73.5 38.7-73.5 82.6 0 87.8 80.4 101.3 150.4 101.3h48.2c70.3 0 150.6-13.4 150.6-101.3zm-82.6-55.1c-25.8 0-36.7 34.2-36.7 55.1s10.9 55.1 36.7 55.1 36.7-34.2 36.7-55.1-10.9-55.1-36.7-55.1z"></path></svg>
      </div>
      -->

      <p class="red mt-4" v-if="notproFlag">Amacode Proの申込みがされていないアカウントです。<br>申込後、再度ログインをしてください。</p>

      <template v-if="checkLoginState">
        <vs-divider class="mt-4 mb-8"></vs-divider>
        
        <!-- <vs-alert
          color="danger" active="true" class="text-center btn-danger">
          <a href="https://pro.amacode.app" class="" target="_blank">お申し込みはこちらから。</a>
        </vs-alert>
         -->
        <vs-button color="danger" class="mt-4" @click="logoutConfirm">ログアウト</vs-button>
      </template>

    </div>
    
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'

export default {
  data () {
    return {
      email: '',
      password: '',
      checkbox_remember_me: false,
      is_login: false,
      notproFlag: false
    }
  },
  created () {
    // メッセージを日本語に設定する
    this.$validator.localize('ja');
  },
  mounted: function(){
    const state = this.getparamAnalysis('state')
    if (state == 0) {
      this.notproFlag = true
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any() && this.email !== '' && this.password !== ''
    },
    checkLoginState() {
      return this.$store.state.auth.isUserLoggedIn()
    }
  },
  methods: {
    checkLogin () {
      // If user is already logged in notify
      if (this.$store.state.auth.isUserLoggedIn()) {

        // Close animation if passed as payload
        // this.$vs.loading.close()

        this.$vs.notify({
          title: 'Login Attempt',
          text: 'You are already logged in!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }
      return true
    },
    login () {
      // Loading
      this.$vs.loading()

      const payload = {
        checkbox_remember_me: this.checkbox_remember_me,
        userDetails: {
          email: this.email,
          password: this.password
        },
        notify: this.$vs.notify,
        closeAnimation: this.$vs.loading.close
      }
      this.$store.dispatch('auth/loginAttempt', payload)
    },
    // Google login
    loginWithGoogle () {
      this.$store.dispatch('auth/loginWithGoogle', { notify: this.$vs.notify })
    },
    // Apple login
    loginWithApple () {
      this.$store.dispatch('auth/loginWithApple', { notify: this.$vs.notify })
    },

    /*
    // appleログイン
    $scope.gmail = function(){
      $scope.error = null;
      Auth.$signInWithRedirect("google").then(function() {
        // Never called because of page redirect
      }).catch(function(error) {
        console.error("Authentication failed:", error);
      });
    }
    
    $scope.apple = function(){
      $scope.error = null;
      
      var provider = new firebase.auth.OAuthProvider('apple.com');
      firebase.auth().signInWithRedirect(provider);
    }
    */


    // Facebook login
    /*
    loginWithFacebook () {
      this.$store.dispatch('auth/loginWithFacebook', { notify: this.$vs.notify })
    },

    // Twitter login
    loginWithTwitter () {
      this.$store.dispatch('auth/loginWithTwitter', { notify: this.$vs.notify })
    },

    // Github login
    loginWithGithub () {
      this.$store.dispatch('auth/loginWithGithub', { notify: this.$vs.notify })
    },
    */
    registerUser () {
      if (!this.checkLogin()) return
      this.$router.push('/pages/register').catch(() => {})
    },

    logoutConfirm () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'ログアウト',
        text: 'Amacode Proからログアウトしますがよろしいですか？',
        acceptText: 'ログアウトする',
        cancelText: 'しない',
        accept: this.logout
      })
    },
    logout () {
      // if user is logged in via auth0
      // ユーザが auth0 でログインしている場合
      //if (this.$auth.profile) this.$auth.logOut()

      // if user is logged in via firebase
      // ユーザーが firebase 経由でログインしている場合
      const firebaseCurrentUser = firebase.auth().currentUser

      if (firebaseCurrentUser) {
        firebase.auth().signOut().then(() => {
          //this.$router.push('/pages/login').catch(() => {})
          this.$router.go({path:'/pages/login',force: true})
        })
      }
      // If JWT login
      // JWTログインの場合
      /*
      if (localStorage.getItem('accessToken')) {
        localStorage.removeItem('accessToken')
        this.$router.push('/pages/login').catch(() => {})
      }*/

      // Change role on logout. Same value as initialRole of acj.js
      // ログアウト時のロールを変更します。acj.jsのinitialRoleと同じ値
      this.$acl.change('admin')
      localStorage.removeItem('userInfo')

      // This is just for demo Purpose. If user clicks on logout -> redirect
      // これはあくまでもデモのためのものです。ログアウト→リダイレクトをクリックすると
      //this.$router.push('/pages/login').catch(() => {})
      this.$router.go({path:'/pages/login',force: true})
    },
    // ■ getパラメータを解析して返却する
    getparamAnalysis(params) {
      const param = this.$route.query[params]
      return param
    },
  }
}

</script>


<style lang="scss">
#page-login {
  .login-inner{
    width:430px;
  }
  .social-login-buttons {
    .vs-button{
      width: 100%;
    }
    .btn-gmail{
      display:flex;
      justify-content: center;
      align-items: center;
      background-color:#ffffff;
      border: 1px solid #757575;
      color:#757575;
      line-height: 1;
      &:hover{
        //background-color:#6dc548;
      }
      i{
        display:block;
        width: 15px;
        margin-right: 8px;
      }
    }
    .btn-apple{
      display:flex;
      justify-content: center;
      align-items: center;
      //border:1px solid #050708;
      background-color:#050708;
      line-height: 1;
      &:hover{
        //background-color:#ffffff;
      }
      i{
        display:block;
        width: 15px;
        margin-right: 8px;
      }
    }
  }
}
.con-vs-checkbox{
  margin-left:0;
}
.items-center{
  justify-content: center;
}
.red{
  font-weight:bold;
  color: red;
}

</style>
